import { Routes } from '@angular/router';

import { AuthGuard } from '@plugins/client/auth';
import { AppGuard } from '@plugins/client/routing/app.guard';
import { createTranslationGuard } from '@plugins/client/translate/guards';

import { canActivate404 } from './guards/404.guard';
import {
  backofficeGuards,
  frontofficeGuards,
} from './guards/root-routes.guard';

const missingImport = () =>
  import('./components/pages/missing-template/missing.component').then(
    (im) => im.MissingTemplateComponent,
  );
const appImport = () => import('./app.component').then((im) => im.AppComponent);

export const routes: Routes = [
  {
    path: '',
    canActivate: [AppGuard, AuthGuard],
    canActivateChild: [createTranslationGuard(appImport)],
    children: [
      {
        path: 'admin',
        canActivateChild: backofficeGuards,
        data: { role: 'editor' },
        loadChildren: () => import('./backoffice/backoffice.routes'),
      },
      {
        path: '404',
        canActivate: [canActivate404, createTranslationGuard(missingImport)],
        loadComponent: missingImport,
      },
      {
        path: '',
        loadChildren: () => import('./frontend/frontend.routes'),
        canActivate: frontofficeGuards,
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];
